import React from "react";

export function Intro() {
  return (
    <p>
      <br />
      Hi there! I'm Sam, a software developer with an interest in web
      development. Currently, I'm diving deep into the world of code as a
      student designer, where I get to blend my love for creativity and
      technology. My journey in software development has been incredibly
      rewarding, and I find joy in crafting user-friendly web experiences. I
      work with multiple programming languages, but my favorite things are SQL
      and web development. Additionally, I have finished my Bachelor's of
      Computer Science at SEMO and am starting my Master's. I am currently
      working on this website, among other projects. This website currently works
      as a portfolio, but I plan to add more as I create. Currently, I have on
      display the code from my beginner websites, but I plan to replace them
      with future works.
      <br />
      When I'm not coding, you can often find me reading or playing video games
      like Stardew Valley or Minecraft. I believe that both reading and gaming
      offer unique perspectives that enrich my problem-solving skills and
      creativity. Additionally, I love spending time with my adorable Chihuahua,
      Sissy. She's the little spark of joy in my life, and we enjoy having cozy
      evenings together.
    </p>
  );
}
